import axiosPublicClient from "../../../../../../axiosPublicClient"

const service = async (data) => {
    const result = await axiosPublicClient.post(`/skip-pre-check`, data)

    return result.data
}

export default service
